import { Printer, Download, Edit2, Save, Send, Copy, X, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export const InvoiceActions = ({
  isEditing,
  setIsEditing,
  invoiceInfo,
  companyInfo,
  customerInfo,
  lineItems,
  subtotal,
  tax,
  total,
  onSave,
  onCancel,
  onDownloadPDF,
  onPrintPDF,
  onSendEmail
}) => {
  const handlePrint = () => {
    if (onPrintPDF) {
      onPrintPDF();
    } else {
      window.print();
    }
  };

  const handleDownloadPDF = () => {
    if (onDownloadPDF) {
      onDownloadPDF();
    } else {
      toast.success("PDF Download", {
        description: "Invoice PDF would be downloaded in a full implementation."
      });
    }
  };

  const handleSendEmail = () => {
    if (onSendEmail) {
      onSendEmail();
    } else {
      if (!customerInfo.email) {
        toast.error("No Email", {
          description: "Customer email is required to send the invoice."
        });
        return;
      }
      toast.success("Email Sent", {
        description: `Invoice sent to ${customerInfo.email}`
      });
    }
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    toast.success("Link Copied", {
      description: "Invoice link copied to clipboard."
    });
  };

  const handleSave = () => {
    if (onSave) {
      onSave();
    } else {
      setIsEditing(false);
      toast.success("Invoice Saved", {
        description: `Invoice #${invoiceInfo.number} has been saved successfully.`
      });
    }
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    } else {
      setIsEditing(false);
    }
  };

  return (
    <div className="flex flex-wrap items-center justify-between gap-4">
      {/* Left Actions */}
      <div className="flex items-center gap-2">
        {isEditing ? (
          <>
            <Button
              onClick={handleSave}
              className="gap-2 bg-success hover:bg-success/90 text-success-foreground"
            >
              <Save className="w-4 h-4" />
              Save Invoice
            </Button>
            <Button
              variant="outline"
              onClick={handleCancel}
              className="gap-2"
            >
              <X className="w-4 h-4" />
              Cancel
            </Button>
          </>
        ) : (
          <Button
            variant="outline"
            onClick={() => setIsEditing(true)}
            className="gap-2"
          >
            <Edit2 className="w-4 h-4" />
            Edit Invoice
          </Button>
        )}
      </div>

      {/* Right Actions */}
      {!isEditing && (
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={handleCopyLink}
            className="gap-2"
          >
            <Copy className="w-4 h-4" />
            <span className="hidden sm:inline">Copy Link</span>
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={handlePrint}
            className="gap-2"
          >
            <Printer className="w-4 h-4" />
            <span className="hidden sm:inline">Print</span>
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={handleDownloadPDF}
            className="gap-2"
          >
            <Download className="w-4 h-4" />
            <span className="hidden sm:inline">PDF</span>
          </Button>
          <Button
            size="sm"
            onClick={handleSendEmail}
            className="gap-2 bg-primary text-primary-foreground hover:bg-primary/90"
            data-testid="send-email-btn"
          >
            <Mail className="w-4 h-4" />
            <span className="hidden sm:inline">Email</span>
          </Button>
        </div>
      )}
    </div>
  );
};
